/*
Product Name: dhtmlxSuite
Version: 5.0.2
Edition: Professional
License: content of this file is covered by DHTMLX Commercial or Enterprise license. Usage without proper license is prohibited. To obtain it contact sales@dhtmlx.com
Copyright UAB Dinamenta http://www.dhtmlx.com
*/
var dhx = {
    version: "5.0.2",
    skin: null,
    skinDetect: function (a) {
        var c = Math.floor(dhx4.readFromCss(a + "_skin_detect") / 10) * 10;
        return ({
            10: "dhx_skyblue",
            20: "dhx_web",
            30: "dhx_terrace",
            40: "material"
        }[c] || null);
    },
    readFromCss: function (e, g, h) {
        var c = document.createElement("DIV");
        c.className = e;
        if (document.body.firstChild != null) {
            document.body.insertBefore(c, document.body.firstChild);
        }
        else {
            document.body.appendChild(c);
        }
        if (typeof h == "string") {
            c.innerHTML = h;
        }
        var a = c[g || "offsetWidth"];
        c.parentNode.removeChild(c);
        c = null;
        return a;
    },
    lastId: 1,
    newId: function () {
        return this.lastId++;
    },
    zim: {
        data: {},
        step: 5,
        first: function () {
            return 100;
        },
        last: function () {
            var e = this.first();
            for (var c in this.data) {
                e = Math.max(e, this.data[c]);
            }
            return e;
        },
        reserve: function (a) {
            this.data[a] = this.last() + this.step;
            return this.data[a];
        },
        clear: function (a) {
            if (this.data[a] != null) {
                this.data[a] = null;
                delete this.data[a];
            }
        }
    },
    //将字符串转换成boolean
    s2b: function (a) {
        if (typeof a == "string") {
            a = a.toLowerCase();
        }
        return (a == true ||
            a == 1 ||
            a == "true" ||
            a == "1" ||
            a == "yes" ||
            a == "y" ||
            a == "on");
    },
    //将字符串转换成 json对象
    s2j: function (s) {
        var obj = null;
        dhx4.temp = null;
        try {
            eval("dhx4.temp=" + s);
        }
        catch (e) {
            dhx4.temp = null;
        }
        obj = dhx4.temp;
        dhx4.temp = null;
        return obj;
    },
    //获取元素左边的距离
    absLeft: function (a) {
        if (typeof a == "string") {
            a = document.getElementById(a);
        }
        return this.getOffset(a).left;
    },
    //获取顶部的距离
    absTop: function (a) {
        if (typeof a == "string") {
            a = document.getElementById(a);
        }
        return this.getOffset(a).top;
    },
    //获取当前元素的offset相关信息  offsetTop 距离上方或上层控件的位置
    _aOfs: function (a) {
        var e = 0, c = 0;
        while (a) {
            e = e + parseInt(a.offsetTop);
            c = c + parseInt(a.offsetLeft);
            a = a.offsetParent;
        }
        return { top: e, left: c };
    },
    /**
     * 私有方法 为getOffset提供调用
     * @param g
     * @private
     */
    _aOfsRect: function (g) {
        var m = g.getBoundingClientRect();
        var n = document.body;
        var c = document.documentElement;
        var a = window.pageYOffset || c.scrollTop || n.scrollTop;
        var h = window.pageXOffset || c.scrollLeft || n.scrollLeft;
        var l = c.clientTop || n.clientTop || 0;
        var o = c.clientLeft || n.clientLeft || 0;
        var r = m.top + a - l;
        var e = m.left + h - o;
        return { top: Math.round(r), left: Math.round(e) };
    },
    /**
     * 获取传入的dom元素 的offset信息
     * @param a
     */
    getOffset: function (a) {
        if (a.getBoundingClientRect) {
            return this._aOfsRect(a);
        }
        else {
            return this._aOfs(a);
        }
    },
    //判断传入的值 是否是object
    _isObj: function (a) {
        return a != null && typeof a == "object" && typeof a.length == "undefined";
    },
    //复制对象
    _copyObj: function (g) {
        var e = null;
        if (this._isObj(g)) {
            e = {};
            for (var c in g) {
                if (typeof g[c] == "object" && g[c] != null) {
                    e[c] = this._copyObj(g[c]);
                }
                else {
                    e[c] = g[c];
                }
            }
        }
        else {
            e = [];
            for (var cNum = 0; cNum < g.length; cNum++) {
                if (typeof g[cNum] == "object" && g[cNum] != null) {
                    e[cNum] = this._copyObj(g[cNum]);
                }
                else {
                    e[cNum] = g[cNum];
                }
            }
        }
        return e;
    },
    /**
     * 获取当前屏幕的范围
     * {left: 0, right: 1204, top: 0, bottom: 616}
     */
    screenDim: function () {
        var a = navigator.userAgent.indexOf("MSIE") >= 0;
        var c = {};
        c.left = document.body.scrollLeft;
        c.right = c.left + (window.innerWidth || document.body.clientWidth);
        c.top = Math.max((a ? document.documentElement : document.getElementsByTagName("html")[0])
            .scrollTop, document.body.scrollTop);
        c.bottom =
            c.top +
                (a
                    ? Math.max(document.documentElement.clientHeight || 0, document.documentElement.offsetHeight || 0)
                    : window.innerHeight);
        return c;
    },
    selectTextRange: function (h, m, c) {
        h = typeof h == "string" ? document.getElementById(h) : h;
        var a = h.value.length;
        m = Math.max(Math.min(m, a), 0);
        c = Math.min(c, a);
        if (h.setSelectionRange) {
            try {
                h.setSelectionRange(m, c);
            }
            catch (l) { }
        }
        else {
            if (h.createTextRange) {
                var g = h.createTextRange();
                g.moveStart("character", m);
                g.moveEnd("character", c - a);
                try {
                    g.select();
                }
                catch (l) { }
            }
        }
    },
    transData: null,
    /**
     * 动画检测
     * {transProp: "WebkitTransition", transEv: "webkitTransitionEnd"}
     */
    transDetect: function () {
        if (this.transData == null) {
            this.transData = { transProp: false, transEv: null };
            var e = {
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd",
                OTransition: "oTransitionEnd",
                msTransition: "transitionend",
                transition: "transitionend"
            };
            for (var c in e) {
                if (this.transData.transProp == false &&
                    document.documentElement.style[c] != null) {
                    this.transData.transProp = c;
                    this.transData.transEv = e[c];
                }
            }
            e = null;
        }
        return this.transData;
    },
    _xmlNodeValue: function (a) {
        var e = "";
        for (var c = 0; c < a.childNodes.length; c++) {
            e +=
                a.childNodes[c].nodeValue != null
                    ? a.childNodes[c].nodeValue
                        .toString()
                        .replace(/^[\n\r\s]{0,}/, "")
                        .replace(/[\n\r\s]{0,}$/, "")
                    : "";
        }
        return e;
    }
};
var dhx4 = dhx;
dhx4.isMacOS = (function () {
    if (navigator.userAgent.indexOf("Macintosh") != -1) {
        return true;
    }
    return false;
})();
dhx4.isIE =
    navigator.userAgent.indexOf("MSIE") >= 0 ||
        navigator.userAgent.indexOf("Trident") >= 0;
dhx4.isIE6 =
    window.XMLHttpRequest == null &&
        navigator.userAgent.indexOf("MSIE") >= 0;
dhx4.isIE7 =
    navigator.userAgent.indexOf("MSIE 7.0") >= 0 &&
        navigator.userAgent.indexOf("Trident") < 0;
dhx4.isIE8 =
    navigator.userAgent.indexOf("MSIE 8.0") >= 0 &&
        navigator.userAgent.indexOf("Trident") >= 0;
dhx4.isIE9 =
    navigator.userAgent.indexOf("MSIE 9.0") >= 0 &&
        navigator.userAgent.indexOf("Trident") >= 0;
dhx4.isIE10 =
    navigator.userAgent.indexOf("MSIE 10.0") >= 0 &&
        navigator.userAgent.indexOf("Trident") >= 0 &&
        window.navigator.pointerEnabled != true;
dhx4.isIE11 =
    navigator.userAgent.indexOf("Trident") >= 0 &&
        window.navigator.pointerEnabled == true;
dhx4.isEdge = navigator.userAgent.indexOf("Edge") >= 0;
dhx4.isOpera = navigator.userAgent.indexOf("Opera") >= 0;
dhx4.isChrome = navigator.userAgent.indexOf("Chrome") >= 0 && !dhx4.isEdge;
dhx4.isKHTML =
    (navigator.userAgent.indexOf("Safari") >= 0 ||
        navigator.userAgent.indexOf("Konqueror") >= 0) &&
        !dhx4.isEdge;
dhx4.isFF = navigator.userAgent.indexOf("Firefox") >= 0;
dhx4.isIPad = navigator.userAgent.search(/iPad/gi) >= 0;
//是否可以加载数据
dhx4._enableDataLoading = function (m, e, l, h, n) {
    if (n == "clear") {
        for (var c in m._dhxdataload) {
            m._dhxdataload[c] = null;
            delete m._dhxdataload[c];
        }
        m._loadData = null;
        m._dhxdataload = null;
        m.load = null;
        m.loadStruct = null;
        m = null;
        return;
    }
    m._dhxdataload = {
        initObj: e,
        xmlToJson: l,
        xmlRootTag: h,
        onBeforeXLS: null
    };
    m._loadData = function (v, w, x) {
        if (arguments.length == 2) {
            x = w;
            w = null;
        }
        var u = null;
        if (arguments.length == 3) {
            x = arguments[2];
        }
        var s = null;
        if (typeof v == "string") {
            s = v.replace(/^\s{1,}/, "").replace(/\s{1,}$/, "");
            var C = new RegExp("^<" + this._dhxdataload.xmlRootTag);
            if (C.test(s.replace(/^<\?xml[^?]*\?>\s*/, ""))) {
                u = dhx4.ajax.parse(v);
                if (u != null) {
                    u = this[this._dhxdataload.xmlToJson].apply(this, [u]);
                }
            }
            if (u == null &&
                (s.match(/^[\s\S]*{[.\s\S]*}[\s\S]*$/) != null ||
                    s.match(/^[\s\S]*\[[.\s\S]*\][\s\S]*$/) != null)) {
                u = dhx4.s2j(s);
            }
            if (u == null) {
                this.callEvent("onXLS", []);
                var r = [];
                if (typeof this._dhxdataload.onBeforeXLS == "function") {
                    s = this._dhxdataload.onBeforeXLS.apply(this, [v]);
                    if (s != null && typeof s == "object") {
                        if (s.url != null) {
                            v = s.url;
                        }
                        if (s.params != null) {
                            for (var y in s.params) {
                                r.push(y + "=" + encodeURIComponent(s.params[y]));
                            }
                        }
                    }
                }
                var A = this;
                var o = function (a) {
                    var D = null;
                    if ((a.xmlDoc.getResponseHeader("Content-Type") || "").search(/xml/gi) >= 0 ||
                        a.xmlDoc.responseText.replace(/^\s{1,}/, "").match(/^</) != null) {
                        D = A[A._dhxdataload.xmlToJson].apply(A, [a.xmlDoc.responseXML]);
                    }
                    else {
                        D = dhx4.s2j(a.xmlDoc.responseText);
                    }
                    if (D != null) {
                        A[A._dhxdataload.initObj].apply(A, [D, v]);
                    }
                    A.callEvent("onXLE", []);
                    if (x != null) {
                        if (typeof x == "function") {
                            x.apply(A, []);
                        }
                        else {
                            if (typeof window[x] == "function") {
                                window[x].apply(A, []);
                            }
                        }
                    }
                    o = x = null;
                    D = a = A = null;
                };
                r = r.join("&") + (typeof w == "string" ? "&" + w : "");
                if (dhx4.ajax.method == "post") {
                    dhx4.ajax.post(v, r, o);
                }
                else {
                    if (dhx4.ajax.method == "get") {
                        dhx4.ajax.get(v + (r.length > 0 ? (v.indexOf("?") > 0 ? "&" : "?") + r : ""), o);
                    }
                }
                return;
            }
        }
        else {
            if (typeof v.documentElement == "object" ||
                (typeof v.tagName != "undefined" &&
                    typeof v.getElementsByTagName != "undefined" &&
                    v.getElementsByTagName(this._dhxdataload.xmlRootTag).length > 0)) {
                u = this[this._dhxdataload.xmlToJson].apply(this, [v]);
            }
            else {
                u = window.dhx4._copyObj(v);
            }
        }
        if (u != null) {
            this[this._dhxdataload.initObj].apply(this, [u]);
        }
        if (x != null) {
            if (typeof x == "function") {
                x.apply(this, []);
            }
            else {
                if (typeof window[x] == "function") {
                    window[x].apply(this, []);
                }
            }
            x = null;
        }
    };
    if (n != null) {
        var g = { struct: "loadStruct", data: "load" };
        for (var c_1 in n) {
            if (n[c_1] == true) {
                m[g[c_1]] = function () {
                    return this._loadData.apply(this, arguments);
                };
            }
        }
    }
    m = null;
};
//去掉前后空格
dhx4.trim = function (a) {
    return String(a)
        .replace(/^\s{1,}/, "")
        .replace(/\s{1,}$/, "");
};
//是否可以添加事件
dhx4._eventable = function (a, c) {
    if (c == "clear") {
        a.detachAllEvents();
        a.dhxevs = null;
        a.attachEvent = null;
        a.detachEvent = null;
        a.checkEvent = null;
        a.callEvent = null;
        a.detachAllEvents = null;
        a = null;
        return;
    }
    a.dhxevs = { data: {} };
    a.attachEvent = function (e, h) {
        e = String(e).toLowerCase();
        if (!this.dhxevs.data[e]) {
            this.dhxevs.data[e] = {};
        }
        var g = window.dhx4.newId();
        this.dhxevs.data[e][g] = h;
        return g;
    };
    a.detachEvent = function (l) {
        for (var g in this.dhxevs.data) {
            var h = 0;
            for (var e in this.dhxevs.data[g]) {
                if (e == l) {
                    this.dhxevs.data[g][e] = null;
                    delete this.dhxevs.data[g][e];
                }
                else {
                    h++;
                }
            }
            if (h == 0) {
                this.dhxevs.data[g] = null;
                delete this.dhxevs.data[g];
            }
        }
    };
    a.checkEvent = function (e) {
        e = String(e).toLowerCase();
        return this.dhxevs.data[e] != null;
    };
    a.callEvent = function (g, l) {
        g = String(g).toLowerCase();
        if (this.dhxevs.data[g] == null) {
            return true;
        }
        var h = true;
        for (var e in this.dhxevs.data[g]) {
            h = this.dhxevs.data[g][e].apply(this, l) && h;
        }
        return h;
    };
    a.detachAllEvents = function () {
        for (var g in this.dhxevs.data) {
            for (var e in this.dhxevs.data[g]) {
                this.dhxevs.data[g][e] = null;
                delete this.dhxevs.data[g][e];
            }
            this.dhxevs.data[g] = null;
            delete this.dhxevs.data[g];
        }
    };
    a = null;
};
dhx4._eventable(dhx4);
//ajax相关方法
dhx4.ajax = {
    cache: false,
    method: "get",
    parse: function (a) {
        if (typeof a !== "string") {
            return a;
        }
        var c = null;
        a = a.replace(/^[\s]+/, "");
        if (window.DOMParser && !dhx4.isIE) {
            c = new window.DOMParser().parseFromString(a, "text/xml");
        }
        else {
            if (window.ActiveXObject !== window.undefined) {
                c = new window.ActiveXObject("Microsoft.XMLDOM");
                c.async = "false";
                c.loadXML(a);
            }
        }
        return c;
    },
    xmltop: function (a, h, g) {
        if (typeof h.status == "undefined" || h.status < 400) {
            var xml = !h.responseXML
                ? dhx4.ajax.parse(h.responseText || h)
                : h.responseXML || h;
            if (xml && xml.documentElement !== null) {
                try {
                    if (!xml.getElementsByTagName("parsererror").length) {
                        return xml.getElementsByTagName(a)[0];
                    }
                }
                catch (c) { }
            }
        }
        if (g !== -1) {
            dhx4.callEvent("onLoadXMLError", ["Incorrect XML", arguments[1], g]);
        }
        return document.createElement("DIV");
    },
    xpath: function (g, a) {
        if (!a.nodeName) {
            a = a.responseXML || a;
        }
        if (dhx4.isIE) {
            try {
                return a.selectNodes(g) || [];
            }
            catch (l) {
                return [];
            }
        }
        else {
            var h = [];
            var md;
            var c = (a.ownerDocument || a).evaluate(g, a, null, XPathResult.ANY_TYPE, null);
            while ((md = c.iterateNext())) {
                h.push(md);
            }
            return h;
        }
    },
    query: function (a) {
        dhx4.ajax._call(a.method || "GET", a.url, a.data || "", a.async || true, a.callback, null, a.headers);
    },
    get: function (a, c) {
        return this._call("GET", a, null, true, c);
    },
    getSync: function (a) {
        return this._call("GET", a, null, false);
    },
    put: function (c, a, e) {
        return this._call("PUT", c, a, true, e);
    },
    del: function (c, a, e) {
        return this._call("DELETE", c, a, true, e);
    },
    post: function (c, a, e) {
        if (arguments.length == 1) {
            a = "";
        }
        else {
            if (arguments.length == 2 &&
                (typeof a == "function" || typeof window[a] == "function")) {
                e = a;
                a = "";
            }
            else {
                a = String(a);
            }
        }
        return this._call("POST", c, a, true, e);
    },
    postSync: function (c, a) {
        a = a == null ? "" : String(a);
        return this._call("POST", c, a, false);
    },
    getLong: function (a, c) {
        this._call("GET", a, null, true, c, { url: a });
    },
    postLong: function (c, a, e) {
        if (arguments.length == 2 &&
            (typeof a == "function" || typeof window[a])) {
            e = a;
            a = "";
        }
        this._call("POST", c, a, true, e, { url: c, postData: a });
    },
    _call: function (a, c, e, h, m, r, g) {
        var o = window.XMLHttpRequest && !dhx4.isIE
            ? new XMLHttpRequest()
            : new ActiveXObject("Microsoft.XMLHTTP");
        var l = navigator.userAgent.match(/AppleWebKit/) != null &&
            navigator.userAgent.match(/Qt/) != null &&
            navigator.userAgent.match(/Safari/) != null;
        if (h == true) {
            o.onreadystatechange = function () {
                if (o.readyState == 4 || (l == true && o.readyState == 3)) {
                    if (o.status != 200 || o.responseText == "") {
                        if (!dhx4.callEvent("onAjaxError", [
                            { xmlDoc: o, filePath: c, async: h }
                        ])) {
                            return;
                        }
                    }
                    window.setTimeout(function () {
                        if (typeof m == "function") {
                            m.apply(window, [{ xmlDoc: o, filePath: c, async: h }]);
                        }
                        if (r != null) {
                            if (typeof r.postData != "undefined") {
                                dhx4.ajax.postLong(r.url, r.postData, m);
                            }
                            else {
                                dhx4.ajax.getLong(r.url, m);
                            }
                        }
                        m = null;
                        o = null;
                    }, 1);
                }
            };
        }
        if (a == "GET") {
            c += this._dhxr(c);
        }
        o.open(a, c, h);
        if (g != null) {
            for (var n in g) {
                o.setRequestHeader(n, g[n]);
            }
        }
        else {
            if (a == "POST" || a == "PUT" || a == "DELETE") {
                o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            }
            else {
                if (a == "GET") {
                    e = null;
                }
            }
        }
        o.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        o.send(e);
        if (h != true) {
            if (o.readyState == 4 || (l == true && o.readyState == 3)) {
                if (o.status != 200 || o.responseText == "") {
                    dhx4.callEvent("onAjaxError", [{ xmlDoc: o, filePath: c, async: h }]);
                }
            }
        }
        return { xmlDoc: o, filePath: c, async: h };
    },
    _dhxr: function (a, c) {
        if (this.cache != true) {
            if (a.match(/^[?&]$/) == null) {
                a = a.indexOf("?") >= 0 ? "&" : "?";
            }
            if (typeof c == "undefined") {
                c = true;
            }
            return a + "dhxr" + new Date().getTime() + (c == true ? "=1" : "");
        }
        return "";
    }
};
dhx4.dnd = {
    evs: {},
    p_en: (dhx4.isIE || dhx4.isEdge) &&
        (window.navigator.pointerEnabled || window.navigator.msPointerEnabled),
    _mTouch: function (a) {
        return ((dhx4.isIE10 && a.pointerType == a.MSPOINTER_TYPE_MOUSE) ||
            (dhx4.isIE11 && a.pointerType == "mouse") ||
            (dhx4.isEdge && a.pointerType == "mouse"));
    },
    _touchOn: function (a) {
        if (a == null) {
            a = document.body;
        }
        a.style.touchAction = a.style.msTouchAction = "";
        a = null;
    },
    _touchOff: function (a) {
        if (a == null) {
            a = document.body;
        }
        a.style.touchAction = a.style.msTouchAction = "none";
        a = null;
    }
};
if (window.navigator.pointerEnabled == true) {
    dhx4.dnd.evs = {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
    };
}
else {
    if (window.navigator.msPointerEnabled == true) {
        dhx4.dnd.evs = {
            start: "MSPointerDown",
            move: "MSPointerMove",
            end: "MSPointerUp"
        };
    }
    else {
        if (typeof window.addEventListener != "undefined") {
            dhx4.dnd.evs = {
                start: "touchstart",
                move: "touchmove",
                end: "touchend"
            };
        }
    }
}
window.dhx = window.dhx4 = dhx4;

export {dhx4,dhx};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/dhx4OrDhx/dhx.js